<template>
  <!-- <div class="header-main">
    <div class="header-box1">
      <div class="box-top">
        <div class="box-top-left">
          <span class="box-top_big_title">{{ modeTitle }}</span>
        </div>
        <div class="header_content_right">
          <div class="login_button mar_l_20" v-if="$store.state.isLogin" @click="loginOut">登出</div>
          <div class="login_button mar_l_20" v-else @click="$toLogin">登录</div>
          <a-popover class="mar_l_20" v-else>
            <template slot="content">
              <div class="com_cur myself_choose" @click="$toLogin(0)">个人登录</div>
              <div class="com_cur myself_choose" @click="$toLogin(1)">法人登录</div>
              <div class="com_cur myself_choose" @click="$router.push({ name: 'login' })">个人登录</div>
              <div class="com_cur myself_choose" @click="$router.push({ name: 'login' })">法人登录</div>
            </template>
            <div class="login_button">登录</div>
          </a-popover>
          <a-popover class="mar_l_20">
            <template slot="content">
              <div>
                <div class="com_cur myself_choose" @click="toMyselfIndex">
                  用户中心
                </div>
              </div>
            </template>
            <a-icon type="menu" />
          </a-popover>
        </div>
      </div>
    </div>
    <div class="header-box2">
      <div class="box-bottom">
        <router-link
          class="nav_item"
          :class="[ $route.path  === '/' ? 'nav_item-active' : '']"
          to="/"
          >平台首页</router-link
        >
        <router-link class="nav_item" :class="[$route.path.includes('/investmen/Home') ? 'nav_item-active' : '']" to="/investment/Home">
          科创服务
          <div class="nav__item__sub_panel">
            <div class="nav__item__sub_menus">
              <router-link
                class="nav__item__sub_menus__item"
                :class="[
                  $route.path === '/investment/featureIndustry' ? 'nav__item__sub_menus__item-active' : '',
                ]"
                to="/investment/featureIndustry"
                >特色产业</router-link
              >
              <router-link
                class="nav__item__sub_menus__item"
                :class="[
                  $route.path === '/investment/featurePark' ? 'nav__item__sub_menus__item-active' : '',
                ]"
                to="/investment/featurePark"
                >特色园区</router-link
              >
              <router-link
                class="nav__item__sub_menus__item"
                :class="[
                  $route.path === '/investment/investmentProject' ? 'nav__item__sub_menus__item-active' : '',
                ]"
                to="/investment/investmentProject"
                >招商项目</router-link
              >
            </div>
          </div>
        </router-link>
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >人才服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/policy') ? 'nav_item-active' : '']"
          to="/policy"
          >政策服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >金融服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/law') ? 'nav_item-active' : '']"
          to="/law"
          >法治服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >开放服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >执法服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >中介服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >数据服务</router-link
        >
        <router-link
          class="nav_item"
          :class="[ $route.path.includes('/UndefinedView') ? 'nav_item-active' : '']"
          to="/UndefinedView"
          >项目服务</router-link
        >
      </div>
    </div>
  </div> -->
  <div class="header-main"></div>
</template>

<script>
export default {
  name: 'HeaderTotal',
  props: {
    modeTitle: {
      type: String,
      require: false,
      default: '企业综合服务中心'
    }
  },
  data () {
    return {}
  },
  methods: {
    routerToName (name) {
      if (this.$route.name !== name) {
        this.$router.push({
          name: name
        })
      }
    },
    toMyselfIndex () {
      if (this.$loginModal()) {
        this.$router.push({ name: 'myselfIndex' })
      }
    },
    loginOut () {
      const that = this
      this.$confirm({
        title: '提示',
        content: '确定退出登录？',
        okText: '确定',
        cancelText: '取消',
        centered: true,
        closable: false,
        onOk () {
          that.$loginOut()
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-main {
  box-shadow: 0 2px 3px -1px rgba(0, 0, 0, 0.1);
  position: relative;
  color: #161a23;
}
.header-box1 {
  margin: 0 auto;
  width: 1200px;
}
.header-box2 {
  margin: 0 auto;
  width: 1200px;
}
.box-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}
.box-top-left {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.box-top_big_title {
  font-family: AlimamaShuHeiTi-Bold;
  font-weight: 700;
  font-size: 32px;
  color: #007aea;
  margin-right: 20px;
}
.box-top_title {
  font-family: AlibabaPuHuiTiR;
  font-size: 20px;
  color: #007aea;
}
.box-top_line {
  font-size: 18px;
  color: #d8d8d8;
  margin: 0 20px;
}
.box-top_text {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  line-height: 24px;
}
.header_content_right {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  text-align: left;
  line-height: 32px;
  color: #000000;
  /* color: #FFFFFF; */
}
.mar_l_20 {
  margin-left: 20px;
}
.login_button {
  width: 80px;
  height: 40px;
  background: #FFAF00;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  border-radius: 4px;
  line-height: 40px;
  cursor: pointer;
}
.margin_x_10 {
  margin: 0 10px;
}
.select_content >>> .ant-select-selection {
  border: 0 !important;
  box-shadow: 0 0 0 !important;
  height: 20px;
}
.select_content >>> .ant-select-selection__rendered {
  line-height: 20px;
}
.box-top_button {
  margin-left: 20px;
  width: 104px;
  height: 40px;
  background: #007aea;
  border: 1px solid #007aea;
  border-radius: 25px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
}
.box-top_button:hover,
.box-top_button:focus {
  background: #007aea;
}
.box-bottom {
  font-size: 16px;
  padding-top: 9px;
}
.nav_item {
  border-bottom: 3px solid transparent;
  color: inherit;
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
  height: 36px;
  line-height: 18px;
  margin-right: 20px;
  transition: none;
}
.nav_item:hover {
  font-weight: 700;
}
.nav_item:hover .nav__item__sub_panel {
  opacity: 1;
  transform: translate3d(-50%, 0, 0);
  visibility: visible;
}
.nav_item-active {
  border-color: #0060f0;
  font-weight: 700;
}
a {
  -webkit-text-decoration-skip: objects;
  background-color: transparent;
  color: #0060f0;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
}
.nav__item__sub_panel {
  left: 50%;
  opacity: 0;
  padding-top: 8px;
  position: absolute;
  top: 111px;
  transform: translate3d(-50%, -8px, 0);
  transition: all 0.3s;
  visibility: hidden;
  width: 1200px;
  z-index: 100;
}
.nav__item__sub_menus {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px 0 rgba(22, 26, 35, 0.078);
  color: rgba(22, 26, 35, 0.88);
  display: flex;
  padding: 4px 0;
}
.nav__item__sub_menus__item {
  border-radius: 4px;
  color: inherit;
  display: block;
  font-size: 14px;
  font-weight: 700;
  height: 32px;
  line-height: 32px;
  text-align: center;
  transition: all 0.3s;
  width: 88px;
}
.nav__item__sub_menus__item:hover {
  background: #0060f0;
  color: #fff;
}
.nav__item__sub_menus__item-active {
  background: #0060f0;
  color: #fff;
}
.cur_poi {
  cursor: pointer;
}
.myself_choose:hover {
  color: #007aea;
}
</style>
